import PropTypes from 'prop-types'
import React, { memo } from 'react'
import PageMetaData from '@v4/utils/data/PageMetaData'
import Content from './components/Content'
import { useTestimonial2 } from './Testimonial2.hooks'

const Testimonial2 = props => {
	const [
		{ image, mobileAlignment, text, textConfig, rounding, classes, textEditable, textKey },
		{ handleTextClick, handleImageClick, handleTextChange },
	] = useTestimonial2(props)

	return (
		<Content
			mobileAlignment={mobileAlignment}
			image={image}
			text={text}
			textConfig={textConfig}
			rounding={rounding}
			onTextClick={handleTextClick}
			onImageClick={handleImageClick}
			classes={classes}
			textEditable={textEditable}
			onTextChange={handleTextChange}
			textKey={textKey}
		/>
	)
}

Testimonial2.propTypes = {
	metaData: PropTypes.shape({
		image: PropTypes.instanceOf(PageMetaData),
		text: PropTypes.instanceOf(PageMetaData),
		imageRounding: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Testimonial2)
